import { useState } from 'react'
import { Tooltip, Typography } from 'antd'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { getFirstSubstring } from 'src/core/helpers'
import styles from './StockAlertEmailListColumn.module.scss'
const { Title } = Typography

const StockAlertEmailListColumn = ({ emailList }: { emailList: string[] }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const emailListData = emailList.join(',')

  return (
    <>
      <Tooltip color='blue' title={t('StockAlert.CheckEmails')}>
        <Title
          level={5}
          className={styles['text']}
          onClick={() => setIsModalVisible(true)}
        >
          {getFirstSubstring(emailListData, 25)}...
        </Title>
      </Tooltip>

      <CustomModal
        footer={null}
        title={<Title level={5}>{t('StockAlert.EmailList')}</Title>}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <ol>
          {emailList?.map((email: string, idx: number) => (
            <Title
              type='secondary'
              level={5}
              key={idx}
            >
              {idx + 1} - {email}
            </Title>
          ))}
        </ol>
      </CustomModal>
    </>
  )
}

export default StockAlertEmailListColumn
